<form [formGroup]="personaJuridicaFormGroup">
  <!-- Mostrar solo RUT inicialmente en modo Add -->
  <div [hidden]="mostrarFormularioCompleto" class="row">
    <div class="section-row">
      <div class="row">
        <div class="col-12">
          <p class="info-message">
            <mat-icon>info</mat-icon>
            Ingrese el RUT de la empresa para consultar y cargar automáticamente los datos desde DGI.
          </p>
        </div>
      </div>
      <div class="row">
        <ng-container formGroupName="persona_juridica">
          <mat-form-field class="col-12">
            <input matInput placeholder="RUT:" formControlName="rut" required type="text">
            <mat-error *ngIf="personaJuridicaFormGroup.get('persona_juridica').get('rut')?.hasError('required')">
              Debe ingresar rut
            </mat-error>
          </mat-form-field>
        </ng-container>
      </div>
      <div class="actions" style="margin-top: 20px;">
        <button type="button" routerLink="/main/landing" mat-raised-button>
          {{ 'rpe.vista-usuario.cancelar' | translate }}
        </button>
        <button type="button" mat-raised-button color="primary" (click)="consultarDGI()"
          [disabled]="!isRutValidForConsult() || (empresaDGIIsLoading$ | async)">
          Continuar
          <mat-spinner *ngIf="empresaDGIIsLoading$ | async" diameter="20"
            style="display: inline-block; margin-left: 8px;"></mat-spinner>
        </button>
      </div>
    </div>
  </div>

  <!-- Mostrar formulario completo cuando se carguen los datos o en modo Edit -->
  <div [hidden]="!mostrarFormularioCompleto" class="row">
    <div class="row">
      <ng-container formGroupName="persona_juridica">
        <mat-form-field class="col-12">
          <input matInput placeholder="Denominación social:" formControlName="denominacion_social"
            [disabled]="modificarParam" required>
          <mat-error
            *ngIf="personaJuridicaFormGroup.get('persona_juridica')?.get('denominacion_social')?.hasError('required')">
            Debe ingresar denominación social
          </mat-error>
        </mat-form-field>
      </ng-container>
    </div>

    <div class="section-row">
      <div class="row">
        <ng-container formGroupName="persona_juridica">
          <mat-form-field class="col-12">
            <input matInput placeholder="RUT:" formControlName="rut" required type="text" [disabled]="empresaDGILoaded">
            <mat-spinner *ngIf="empresaDGIIsLoading$ | async" diameter="20" matSuffix></mat-spinner>
            <mat-error *ngIf="personaJuridicaFormGroup.get('persona_juridica').get('rut')?.hasError('required')">
              Debe ingresar rut
            </mat-error>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="section-row">
      <div class="row">
        <ng-container formGroupName="persona_juridica">
          <mat-form-field class="col-12">
            <input matInput placeholder="Nombre fantasía:" formControlName="nombre_fantasia"
              [disabled]="modificarParam">
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="section-row">
      <ng-container formGroupName="persona_juridica">
        <mat-form-field class="col-12">
          <mat-label>Naturaleza jurídica: </mat-label>
          <mat-select formControlName="naturaleza_juridica_id" required>
            <mat-option *ngFor="let natJuridica of formInput.naturalezas_juridicas" [value]="natJuridica.id">
              {{natJuridica.nombre}}
            </mat-option>
          </mat-select>
          <mat-error
            *ngIf="personaJuridicaFormGroup.get('persona_juridica').get('naturaleza_juridica_id')?.hasError('required')">
            Debe ingresar una naturaleza jurídica
          </mat-error>
        </mat-form-field>
      </ng-container>
    </div>

    <div class="section-row">
      <div class="row">
        <ng-container formGroupName="persona_juridica">
          <mat-form-field class="col-12">
            <input matInput placeholder="Número de BPS:" formControlName="bps" required>
            <mat-error *ngIf="personaJuridicaFormGroup.get('persona_juridica').get('bps')?.hasError('required')">
              Debe ingresar el número de BPS
            </mat-error>
          </mat-form-field>
        </ng-container>
      </div>
    </div>

    <div class="section-row flex" *ngIf="!hideCertificadoNotarial">
      <div class="row full-width flex">
        <ng-container formGroupName="persona_juridica" *ngIf="!linkCertificadoNotarial; else link">
          <mat-form-field appearance="standard">
            <mat-label>Certificado notarial: *</mat-label>
            <ng-container>
              <ngx-mat-file-input formControlName="certificado_notarial" accept=".pdf, .jpeg, .jpg, .png, .gif"
                (change)="onFileChange('certificado_notarial')" placeholder="Certificado notarial">
              </ngx-mat-file-input>
            </ng-container>
            <mat-icon matSuffix>
              <fa-icon icon="paperclip"></fa-icon>
            </mat-icon>
            <mat-hint align="end">
              <div class="flex-tooltip">
                <rpe-mat-icon-tooltip [matIconOverlayInput]="overlayInput"></rpe-mat-icon-tooltip>
                <span>Más información</span>
              </div>
            </mat-hint>
            <mat-hint align="end">Tamaño máximo 10 MB en formato .pdf, .jpeg, .jpg, .png o .gif</mat-hint>
            <mat-error>Debe ingresar un archivo con extensión .pdf, .jpeg, .jpg, .png o .gif, menor a 10 MB</mat-error>
          </mat-form-field>
        </ng-container>
        <ng-template #link>
          <a href="{{linkCertificadoNotarial}}" target="_blank">Ver certificado
            notarial</a>
          <ng-container *ngIf="!modificarParam">
            <rpe-ui-button icon="upload" (onClick)="uploadNewCertificadoNotarial()">Subir nuevo archivo</rpe-ui-button>
          </ng-container>
        </ng-template>
      </div>
    </div>

    <div class="section-row">
      <div class="row">
        <h4 class="secondary-header"> Vínculo laboral</h4>
      </div>
    </div>

    <div class="section-row">
      <ng-container formGroupName="rol">
        <mat-form-field class="col-12">
          <mat-label>Rol:</mat-label>
          <mat-select formControlName="tipo_rol_id" required (selectionChange)="cambioTipoRol($event)">
            <mat-option *ngFor="let tipoRol of listaRoles" [value]="tipoRol.id">
              {{tipoRol.nombre}}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="personaJuridicaFormGroup.get('rol').get('tipo_rol_id')?.hasError('required')">
            Debe ingresar un rol
          </mat-error>
        </mat-form-field>
      </ng-container>
    </div>

    <div class="section-row">
      <div class="row" [hidden]="ocultarAcreditacion()">
        <ng-container formGroupName="rol" *ngIf="!acreditacionRepresentacionLink; else linkAcreditacionRepresentacion">
          <mat-form-field appearance="standard" required>
            <mat-label>Acreditación de representación: *</mat-label>
            <ngx-mat-file-input formControlName="acreditacion_representacion" accept=".pdf, .jpeg, .jpg, .png, .gif"
              (change)="onFileChange('acreditacion_representacion')" placeholder="Acreditación de representación">
            </ngx-mat-file-input>
            <mat-icon matSuffix>
              <fa-icon icon="paperclip"></fa-icon>
            </mat-icon>
            <mat-hint align="end">Tamaño máximo 10 MB en formato .pdf, .jpeg, .jpg, .png o .gif</mat-hint>
            <mat-error>Debe ingresar un archivo con extensión .pdf, .jpeg, .jpg, .png o .gif, menor a 10 MB</mat-error>
          </mat-form-field>
          <mat-hint align="end">
            <div class="flex-tooltip">
              <mat-icon>info</mat-icon>
              <span class="info">{{getInfoAcreditacion()}}</span>
            </div>
          </mat-hint>
        </ng-container>
        <ng-template #linkAcreditacionRepresentacion [hidden]="modificarParam">
          <a href="{{acreditacionRepresentacionLink}}" target="_blank">Ver acreditación de representación</a>
          <ng-container *ngIf="!modificarParam">
            <rpe-ui-button icon="upload" (onClick)="uploadNewAcreditacionRepresentacion()">Subir nuevo
              archivo</rpe-ui-button>
          </ng-container>
        </ng-template>
      </div>
    </div>

    <div class="section-row">
      <div class="row">
        <h4 class="secondary-header"> Domicilio constituido</h4>
      </div>
      <div class="row">
        <ng-container formGroupName="entidad_productiva">
          <rpe-direcciones-geograficas-form #direccion_geografica_constituida
            [formInput]="direccionGeograficaOficinaFormInput"
            (formStatusChanges)="direccionGeograficaOficinaStatusChange($event)"
            (formValueChanges)="direccionGeograficaOficinaChange($event)">
          </rpe-direcciones-geograficas-form>
        </ng-container>
      </div>
    </div>
    <div class="section-row">
      <!-- correspondencia -->
      <div class="flex">
        <div>
          <span>Domicilio fiscal:</span>
        </div>
        <div>
          <mat-radio-group aria-label="" required (change)="handleDireccionGeograficaFiscal($event)">
            <mat-radio-button value="si" [checked]="mismoDomicilioFiscal === 'si'"> Domicilio constituido
            </mat-radio-button>
            <mat-radio-button value="no" [checked]="mismoDomicilioFiscal === 'no'"> Otro </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="row" [hidden]="ocultarOtraDireccionFiscal()">
        <h4 class="secondary-header" style="margin: 10px 0">Domicilio fiscal</h4>
        <ng-container formGroupName="entidad_productiva">
          <rpe-direcciones-geograficas-form #direccion_geografica_fiscal
            [formInput]="direccionGeograficaFiscalFormInput"
            (formStatusChanges)="direccionGeograficaFiscalStatusChange($event)"
            (formValueChanges)="direccionGeograficaFiscalChange($event)">
          </rpe-direcciones-geograficas-form>
        </ng-container>
      </div>

      <!-- termina -->
    </div>

    <div class="section-row">
      <!-- constituida -->
      <div class="flex">
        <div>
          <span>Domicilio para correspondencia:</span>
        </div>
        <div>
          <mat-radio-group aria-label="" required (change)="handleChangeDomicilioCorrespondencia($event)">
            <mat-radio-button value="si" [checked]="true" [checked]="mismoDomicilioCorrespondencia === 'si'"> Domicilio
              constituido </mat-radio-button>
            <mat-radio-button value="no" [checked]="mismoDomicilioCorrespondencia === 'no'"> Otro </mat-radio-button>
          </mat-radio-group>
        </div>
      </div>

      <div class="row" [hidden]="ocultarOtraDireccion()">
        <div class="row">
          <h4 class="secondary-header" style="margin: 10px 0">Domicilio de correspondencia</h4>
        </div>
        <ng-container formGroupName="entidad_productiva">
          <rpe-direcciones-geograficas-form #direccion_geografica_correspondencia
            [formInput]="direccionGeograficaCorrespondenciaFormInput"
            (formStatusChanges)="direccionGeograficaCorrespondenciaStatusChange($event)"
            (formValueChanges)="direccionGeograficaCorrespondenciaChange($event)">
          </rpe-direcciones-geograficas-form>
        </ng-container>
      </div>

    </div>

    <div class="section-row">
      <h4 class="secondary-header">Datos de contacto</h4>
    </div>

    <div class="section-row">
      <h5>Teléfonos</h5>
      <div class="flex-column">
        <div class="row">
          <rpe-telefonos-form [formInput]="formInputTelefono" (formStatusChanges)="telefonoFormStatusChange($event)"
            (formValueChanges)="telefonoFormValueChange($event)"></rpe-telefonos-form>
        </div>
      </div>
    </div>



    <div class="section-row">
      <h5>Correos electrónicos</h5>
      <div class="flex-column">
        <div class="row" style="width: 100%; margin-right: 10px" formArrayName="email_tecnico"
          *ngFor="let oc of email_tecnico.controls; index as i">
          <mat-form-field>
            <input matInput placeholder="Contacto técnico:" [formControlName]="i" required>
          </mat-form-field>
          <div *ngIf="email_tecnico.length > 1">
            <button type="button" class="float-right" mat-icon-button (click)="eliminarUnEmailTecnico(i)" color="warn"
              [disabled]="email_tecnico.length < 2" matTooltip="Eliminar contacto técnico">
              <mat-icon>
                <fa-icon icon="minus"></fa-icon>
              </mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="flex justify-content-start">
        <div class="row">
          <button type="button" class="float-right" (click)="agregarOtroEmailTecnico()" mat-icon-button color="primary"
            matTooltip="Agregar nuevo correo electrónico (técnico)">
            <mat-icon>
              <fa-icon icon="plus"></fa-icon>
            </mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="section-row">
      <div class="flex-column">
        <div class="row" style="width: 100%; margin-right: 10px" formArrayName="email_administrativo"
          *ngFor="let oc of email_administrativo.controls; index as i">
          <mat-form-field>
            <input matInput placeholder="Contacto administrativo:" [formControlName]="i" required>
          </mat-form-field>
          <div *ngIf="email_administrativo.length > 1">
            <button type="button" class="float-right" mat-icon-button (click)="eliminarUnEmailAdministrativo(i)"
              color="warn" [disabled]="email_administrativo.length < 2" matTooltip="Eliminar contacto administrativo">
              <mat-icon>
                <fa-icon icon="minus"></fa-icon>
              </mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="flex justify-content-start">
        <div class="row">
          <button type="button" class="float-right" (click)="agregarOtroEmailAdministrativo()" mat-icon-button
            color="primary" matTooltip="Agregar nuevo correo electrónico (administrativo)">
            <mat-icon>
              <fa-icon icon="plus"></fa-icon>
            </mat-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="section-row">
      <div class="flex-column">
        <div class="row" style="width: 100%; margin-right: 10px" formArrayName="email_facturacion"
          *ngFor="let oc of email_facturacion.controls; index as i">
          <mat-form-field>
            <input matInput placeholder="Contacto facturación:" [formControlName]="i" required>
          </mat-form-field>
          <div *ngIf="email_facturacion.length > 1">
            <button type="button" class="float-right" mat-icon-button (click)="eliminarUnEmailFacturacion(i)"
              color="warn" [disabled]="email_facturacion.length < 2" matTooltip="Eliminar contacto facturación">
              <mat-icon>
                <fa-icon icon="minus"></fa-icon>
              </mat-icon>
            </button>
          </div>
        </div>
      </div>
      <div class="flex justify-content-start">
        <div class="row">
          <button type="button" class="float-right" (click)="agregarOtroEmailFacturacion()" mat-icon-button
            color="primary" matTooltip="Agregar correo electrónico (facturación)">
            <mat-icon>
              <fa-icon icon="plus"></fa-icon>
            </mat-icon>
          </button>
        </div>
      </div>
    </div>
  </div>
</form>